import React, { Component } from "react";
import PropTypes from "prop-types";
import { Field, reduxForm, initialize } from "redux-form";
import { FormattedMessage, injectIntl } from "react-intl";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import { graphql, compose } from "react-apollo";

import cx from "classnames";
import {
  Button,
  FormGroup,
  ControlLabel,
  Spinner,
  FormControl,
} from "react-bootstrap";

import submit from "./submit";
import validate from "./validate";
import messages from "../../locale/messages";

import s from "./InboxMessageForm.css";
import bt from "../../components/commonStyle.css";
import GetHostEmailTemplateQuery from "./GetHostEmailTemplate.graphql";
import { DAYS_COUNT_INTERVAL, DEFAULT_NOTIFY_EMAIL, HOURS_COUNT_INTERVAL } from "../../constants";
import InputFieldComponent from "../Common/FormField/InputFieldComponent";

class InboxMessageForm extends React.Component {
  static propTypes = {
    getHostEmailTemplateData: PropTypes.shape({
      hostId: PropTypes.string,
      id: PropTypes.number,
      loading: PropTypes.bool,
      getHostEmailSetting: PropTypes.shape({
        id: PropTypes.number,
        beforeCheckInContent: PropTypes.string,
        afterCheckInContent: PropTypes.string,
        beforeCheckOutContent: PropTypes.string,
        afterCheckOutContent: PropTypes.string,
        beforeCheckInSubject: PropTypes.string,
        afterCheckInSubject: PropTypes.string,
        beforeCheckOutSubject: PropTypes.string,
        afterCheckOutSubject: PropTypes.string,
        isEnableBeforeCheckIn: PropTypes.number,
        dayBeforeCheckIn: PropTypes.number,
        isEnableAfterCheckIn: PropTypes.number,
        dayAfterCheckIn: PropTypes.number,
        isEnableBeforeCheckOut: PropTypes.number,
        dayBeforeCheckOut: PropTypes.number,
        isEnableAfterCheckOut: PropTypes.number,
        dayAfterCheckOut: PropTypes.number,
        timeBeforeCheckIn: PropTypes.string,
        timeAfterCheckIn: PropTypes.string,
        timeBeforeCheckOut: PropTypes.string,
        timeAfterCheckOut: PropTypes.string,
        timeBeforeCheckInPeriod: PropTypes.string,
        timeAfterCheckInPeriod: PropTypes.string,
        timeBeforeCheckOutPeriod: PropTypes.string,
        timeAfterCheckOutPeriod: PropTypes.string,
      }),
    }),
    formatMessage: PropTypes.any,
    initialValues: PropTypes.shape({
      id: PropTypes.number,
      beforeCheckInContent: PropTypes.string,
      afterCheckInContent: PropTypes.string,
      beforeCheckOutContent: PropTypes.string,
      afterCheckOutContent: PropTypes.string,
      beforeCheckInSubject: PropTypes.string,
      afterCheckInSubject: PropTypes.string,
      beforeCheckOutSubject: PropTypes.string,
      afterCheckOutSubject: PropTypes.string,
      isEnableBeforeCheckIn: PropTypes.number,
      dayBeforeCheckIn: PropTypes.number,
      isEnableAfterCheckIn: PropTypes.number,
      dayAfterCheckIn: PropTypes.number,
      isEnableBeforeCheckOut: PropTypes.number,
      dayBeforeCheckOut: PropTypes.number,
      isEnableAfterCheckOut: PropTypes.number,
      dayAfterCheckOut: PropTypes.number,
      timeBeforeCheckIn: PropTypes.string,
      timeAfterCheckIn: PropTypes.string,
      timeBeforeCheckOut: PropTypes.string,
      timeAfterCheckOut: PropTypes.string,
      timeBeforeCheckInPeriod: PropTypes.string,
      timeAfterCheckInPeriod: PropTypes.string,
      timeBeforeCheckOutPeriod: PropTypes.string,
      timeAfterCheckOutPeriod: PropTypes.string,
    }).isRequired,
    dispatch: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    error: PropTypes.any,
  };

  static defaultProps = {
    initialValues: {
      id: null,
      beforeCheckInContent: "",
      afterCheckInContent: "",
      beforeCheckOutContent: "",
      afterCheckOutContent: "",
      beforeCheckInSubject: "",
      afterCheckInSubject: "",
      beforeCheckOutSubject: "",
      afterCheckOutSubject: "",
      isEnableBeforeCheckIn: 0,
      dayBeforeCheckIn: 1,
      isEnableAfterCheckIn: 0,
      dayAfterCheckIn: 1,
      isEnableBeforeCheckOut: 0,
      dayBeforeCheckOut: 1,
      isEnableAfterCheckOut: 0,
      dayAfterCheckOut: 1,
      timeBeforeCheckIn: "",
      timeAfterCheckIn: "",
      timeBeforeCheckOut: "",
      timeAfterCheckOut: "",
      timeBeforeCheckInPeriod: "",
      timeAfterCheckInPeriod: "",
      timeBeforeCheckOutPeriod: "",
      timeAfterCheckOutPeriod: "",
    },
  };

  constructor(props) {
    super(props);
    if (typeof window !== "undefined") {
      this.ReactQuill = require("react-quill");
    }
    this.state = {
      afterCheckin: false,
      beforeCheckin: false,
      afterCheckout: false,
      beforeCheckout: false,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidUpdate(prevProps) {
    const {
      getHostEmailTemplateData: { getHostEmailSetting },
      dispatch,
    } = this.props;
    const prevHostEmailSetting =
      prevProps.getHostEmailTemplateData.getHostEmailSetting;

    if (getHostEmailSetting !== prevHostEmailSetting) {
      dispatch(
        initialize("getHostEmailSetting", {
          id: getHostEmailSetting != null ? getHostEmailSetting.id : null,
          beforeCheckInContent: getHostEmailSetting?.id ? getHostEmailSetting?.beforeCheckInContent : DEFAULT_NOTIFY_EMAIL.BEFORE_CHECKIN.CONTENT,
          afterCheckInContent: getHostEmailSetting?.id ? getHostEmailSetting?.afterCheckInContent : DEFAULT_NOTIFY_EMAIL.AFTER_CHECKIN.CONTENT,
          beforeCheckOutContent: getHostEmailSetting?.id ? getHostEmailSetting?.beforeCheckOutContent : DEFAULT_NOTIFY_EMAIL.BEFORE_CHECKOUT.CONTENT,
          afterCheckOutContent: getHostEmailSetting?.id ? getHostEmailSetting?.afterCheckOutContent : DEFAULT_NOTIFY_EMAIL.AFTER_CHECKOUT.CONTENT,
          beforeCheckInSubject: getHostEmailSetting?.id ? getHostEmailSetting?.beforeCheckInSubject : DEFAULT_NOTIFY_EMAIL.BEFORE_CHECKIN.SUBJECT,
          afterCheckInSubject: getHostEmailSetting?.id ? getHostEmailSetting?.afterCheckInSubject : DEFAULT_NOTIFY_EMAIL.AFTER_CHECKIN.SUBJECT,
          beforeCheckOutSubject: getHostEmailSetting?.id ? getHostEmailSetting?.beforeCheckOutSubject : DEFAULT_NOTIFY_EMAIL.BEFORE_CHECKOUT.SUBJECT,
          afterCheckOutSubject: getHostEmailSetting?.id ? getHostEmailSetting?.afterCheckOutSubject : DEFAULT_NOTIFY_EMAIL.AFTER_CHECKOUT.SUBJECT,
          isEnableBeforeCheckIn:
            getHostEmailSetting?.isEnableBeforeCheckIn || 0,
          dayBeforeCheckIn: getHostEmailSetting?.dayBeforeCheckIn || 1,
          isEnableAfterCheckIn: getHostEmailSetting?.isEnableAfterCheckIn || 0,
          dayAfterCheckIn: getHostEmailSetting?.dayAfterCheckIn || 1,
          isEnableBeforeCheckOut:
            getHostEmailSetting?.isEnableBeforeCheckOut || 0,
          dayBeforeCheckOut: getHostEmailSetting?.dayBeforeCheckOut || 1,
          isEnableAfterCheckOut:
            getHostEmailSetting?.isEnableAfterCheckOut || 0,
          dayAfterCheckOut: getHostEmailSetting?.dayAfterCheckOut || 1,
          timeBeforeCheckIn: getHostEmailSetting?.timeBeforeCheckIn
            ? getHostEmailSetting.timeBeforeCheckIn.split(" ")[0]
            : "",
          timeAfterCheckIn: getHostEmailSetting?.timeAfterCheckIn
            ? getHostEmailSetting.timeAfterCheckIn.split(" ")[0]
            : "",
          timeBeforeCheckOut: getHostEmailSetting?.timeBeforeCheckOut
            ? getHostEmailSetting.timeBeforeCheckOut.split(" ")[0]
            : "",
          timeAfterCheckOut: getHostEmailSetting?.timeAfterCheckOut
            ? getHostEmailSetting.timeAfterCheckOut.split(" ")[0]
            : "",
          timeBeforeCheckInPeriod: getHostEmailSetting?.timeBeforeCheckIn
            ? getHostEmailSetting.timeBeforeCheckIn.split(" ")[1]
            : "AM",
          timeAfterCheckInPeriod: getHostEmailSetting?.timeAfterCheckIn
            ? getHostEmailSetting.timeAfterCheckIn.split(" ")[1]
            : "AM",
          timeBeforeCheckOutPeriod: getHostEmailSetting?.timeBeforeCheckOut
            ? getHostEmailSetting.timeBeforeCheckOut.split(" ")[1]
            : "AM",
          timeAfterCheckOutPeriod: getHostEmailSetting?.timeAfterCheckOut
            ? getHostEmailSetting.timeAfterCheckOut.split(" ")[1]
            : "AM",
        })
      );
    }
  }

  handleChange(fieldName) {
    this.setState({ [fieldName]: !this.state[fieldName] });
  }

  renderQuill = ({
    input,
    label,
    type,
    meta: { touched, error },
    className,
  }) => {
    const { formatMessage } = this.props.intl;
    const ReactQuill = this.ReactQuill;
    let modules = {
      toolbar: [
        [{ header: "1" }, { header: "2" }],
        [{ size: [] }],
        ["bold", "italic", "underline", "strike", "blockquote"],
        [
          { list: "ordered" },
          { list: "bullet" },
          { indent: "-1" },
          { indent: "+1" },
        ],
        ["link"],
      ],
      clipboard: {
        matchVisual: false,
      },
    };

    let formats = [
      "header",
      "size",
      "bold",
      "italic",
      "underline",
      "strike",
      "blockquote",
      "list",
      "bullet",
      "indent",
      "link",
    ];

    return (
      <div>
        <ReactQuill
          {...input}
          value={input.value || ""}
          onChange={(newValue, delta, source) => {
            if (source === "user") {
              input.onChange(newValue);
            }
          }}
          onBlur={(range, source, quill) => {
            if (quill.getHTML() === "<p><br></p>") {
              input.onBlur("");
            } else {
              input.onBlur(quill.getHTML());
            }
          }}
          modules={modules}
          formats={formats}
          theme="snow"
          placeholder={formatMessage(messages.textBoxMessage)}
        />
        {touched && error && (
          <span className={s.errorMessage}>{formatMessage(error)}</span>
        )}
      </div>
    );
  };

  renderDropdown(fieldName, labelMessage) {
    return (
      <FormGroup className={`${s.checkboxGroup}`}>
        <span className={`${s.space} ${s.pt2}`}>
          <label className={s.checkboxLabel}>
            <FormattedMessage {...labelMessage} />
          </label>
        </span>
        <span className={s.dayCheckin}>
          <Field
            name={fieldName}
            component="select" // Use 'select' as the component type
            className={cx("select")} // Add any necessary styling
          >
            {Array.from({ length: DAYS_COUNT_INTERVAL }, (_, i) => i + 1).map(
              (day) => (
                <option key={day} value={day}>
                  {day}
                </option>
              )
            )}
          </Field>
        </span>
      </FormGroup>
    );
  }

  renderTimeDropdown(fieldName, labelMessage) {
    const { formatMessage } = this.props.intl;
    return (
      <FormGroup className={`${s.checkboxGroup}`}>
        <span className={`${s.space} ${s.pt2}`}>
          <label className={s.checkboxLabel}>
            <FormattedMessage {...labelMessage} />
          </label>
        </span>
        <span className={`${s.dayCheckin} ${s.mr3}`}>
          <Field
            name={fieldName}
            component="select" // Use 'select' as the component type
            className={cx("select")} // Add any necessary styling
          >
            {HOURS_COUNT_INTERVAL.map((value) => (
              <option key={value} value={value}>
                {value}
              </option>
            ))}
          </Field>
        </span>
        <span className={`${s.dayCheckin}`}>
          <Field
            name={`${fieldName}Period`}
            component="select"
            className={cx("select", s.periodSelect)}
          >
            <option value="AM">{formatMessage(messages.am)}</option>
            <option value="PM">{formatMessage(messages.pm)}</option>
          </Field>
        </span>
      </FormGroup>
    );
  }

  render() {
    const {
      handleSubmit,
      valid,
      submitting,
      getHostEmailTemplateData: { loading },
    } = this.props;
    const isDisabled = submitting || !valid;
    const { formatMessage } = this.props.intl;

    if (loading) {
      return <div>Loading...</div>;
    }
    return (
      <div
        className={cx("inputFocusColor", "commonListingBg", "noMarginBottom")}
      >
        <div className={` ${s.spaceTop} `}>
          <label className={`${s.someText} ${s.mb0}`}>
            <FormattedMessage {...messages.doNotRemove} />
          </label>
        </div>
        <div className={s.listingLine}></div>
        <form onSubmit={handleSubmit(submit)} className="inbox_form">
          <div className={s.landingMainContent}>
            <div className={`${s.dFlex} ${s.mb10}`}>
              <FormGroup
                className={`${s.checkboxGroup} ${s.mt0} ${s.inboxMessage}`}
              >
                <span>
                  <Field
                    name="isEnableBeforeCheckIn"
                    component="input"
                    type="checkbox"
                    className={s.inboxCheckbox}
                    normalize={(value) => (value ? 1 : 0)}
                  />
                </span>
                <span className={s.space}>
                  <label className={s.checkboxLabel}>
                    <FormattedMessage
                      {...messages.enableMailBeforeCheckinLable}
                    />
                  </label>
                </span>
              </FormGroup>
              <div className={bt.textAlignRight}>
                <Button
                  className={cx(bt.btnPrimary, bt.btnBig, s.customSave)}
                  type="submit"
                  disabled={isDisabled}
                >
                  <FormattedMessage {...messages.save} />
                </Button>
              </div>
            </div>
            <div className={s.mainBox}>
              <div className={s.two}>
                {this.renderDropdown(
                  "dayBeforeCheckIn",
                  messages.daysBeforeCheckinLable
                )}
                {this.renderTimeDropdown(
                  "timeBeforeCheckIn",
                  messages.timeBeforeCheckinLable
                )}
              </div>
            </div>
            <FormGroup className={s.subjectLabel}>
              <ControlLabel>{formatMessage(messages.subject)}</ControlLabel>
              <Field
                name={`beforeCheckInSubject`}
                type="text"
                component={InputFieldComponent}
                placeholder={formatMessage(messages.enterSubject)}
                inputClass={cx(s.faqinputfield)}
              />
            </FormGroup>
            <FormGroup className={`${s.space5} ${s.subjectLabel}`}>
              <ControlLabel>{formatMessage(messages.mailBody)}</ControlLabel>
              {typeof window !== "undefined" && this.ReactQuill ? (
                <Field
                  name="beforeCheckInContent"
                  component={this.renderQuill}
                />
              ) : (
                <div>Rich text editor not available</div>
              )}
            </FormGroup>
          </div>
          <div className={s.listingLine}></div>
          <div className={s.landingMainContent}>
            <div className={`${s.mb10}`}>
              <FormGroup
                className={`${s.checkboxGroup} ${s.mt0} ${s.inboxMessage}`}
              >
                <span>
                  <Field
                    name="isEnableAfterCheckIn"
                    component="input"
                    type="checkbox"
                    className={s.inboxCheckbox}
                    normalize={(value) => (value ? 1 : 0)}
                  />
                </span>
                <span className={s.space}>
                  <label className={s.checkboxLabel}>
                    <FormattedMessage
                      {...messages.enableMailAfterCheckinLable}
                    />
                  </label>
                </span>
              </FormGroup>
            </div>

            <div className={s.mainBox}>
              <div className={s.two}>
                {this.renderDropdown(
                  "dayAfterCheckIn",
                  messages.daysAfterCheckinLable
                )}
                {this.renderTimeDropdown(
                  "timeAfterCheckIn",
                  messages.timeAfterCheckinLable
                )}
              </div>
            </div>
            <FormGroup className={s.subjectLabel}>
              <ControlLabel>{formatMessage(messages.subject)}</ControlLabel>
              <Field
                name={`afterCheckInSubject`}
                type="text"
                component={InputFieldComponent}
                placeholder={formatMessage(messages.enterSubject)}
                inputClass={cx(s.faqinputfield)}
              />
            </FormGroup>
            <FormGroup className={`${s.space5} ${s.subjectLabel}`}>
              <ControlLabel>{formatMessage(messages.mailBody)}</ControlLabel>
              {typeof window !== "undefined" && this.ReactQuill ? (
                <Field
                  name="afterCheckInContent"
                  component={this.renderQuill}
                />
              ) : (
                <div>Rich text editor not available</div>
              )}
            </FormGroup>
          </div>
          <div className={s.listingLine}></div>
          <div className={s.landingMainContent}>
            <div className={`${s.mb10}`}>
              <FormGroup
                className={`${s.checkboxGroup} ${s.mt0} ${s.inboxMessage}`}
              >
                <span>
                  <Field
                    name="isEnableBeforeCheckOut"
                    component="input"
                    type="checkbox"
                    className={s.inboxCheckbox}
                    normalize={(value) => (value ? 1 : 0)}
                  />
                </span>
                <span className={s.space}>
                  <label className={s.checkboxLabel}>
                    <FormattedMessage
                      {...messages.enableMailBeforCheckoutLable}
                    />
                  </label>
                </span>
              </FormGroup>
            </div>

            <div className={s.mainBox}>
              <div className={s.two}>
                {this.renderDropdown(
                  "dayBeforeCheckOut",
                  messages.daysBeforeCheckoutLable
                )}
                {this.renderTimeDropdown(
                  "timeBeforeCheckOut",
                  messages.timeBeforeCheckoutLable
                )}
              </div>
            </div>
            <FormGroup className={s.subjectLabel}>
              <ControlLabel>{formatMessage(messages.subject)}</ControlLabel>
              <Field
                name={`beforeCheckOutSubject`}
                type="text"
                component={InputFieldComponent}
                placeholder={formatMessage(messages.enterSubject)}
                inputClass={cx(s.faqinputfield)}
              />
            </FormGroup>
            <FormGroup className={`${s.space5} ${s.subjectLabel}`}>
              <ControlLabel>{formatMessage(messages.mailBody)}</ControlLabel>
              {typeof window !== "undefined" && this.ReactQuill ? (
                <Field
                  name="beforeCheckOutContent"
                  component={this.renderQuill}
                />
              ) : (
                <div>Rich text editor not available</div>
              )}
            </FormGroup>
          </div>
          <div className={s.listingLine}></div>
          <div className={`${s.checkboxGroup} ${s.mt0}`}>
            <div className={`${s.mb10}`}>
              <FormGroup
                className={`${s.checkboxGroup} ${s.mt0} ${s.inboxMessage}`}
              >
                <span>
                  <Field
                    name="isEnableAfterCheckOut"
                    component="input"
                    type="checkbox"
                    className={s.inboxCheckbox}
                    normalize={(value) => (value ? 1 : 0)}
                  />
                </span>
                <span className={s.space}>
                  <label className={s.checkboxLabel}>
                    <FormattedMessage
                      {...messages.enableMailAfterCheckoutLable}
                    />
                  </label>
                </span>
              </FormGroup>
            </div>

            <div className={s.mainBox}>
              <div className={s.two}>
                {this.renderDropdown(
                  "dayAfterCheckOut",
                  messages.daysAfterCheckoutLable
                )}
                {this.renderTimeDropdown(
                  "timeAfterCheckOut",
                  messages.timeAfterCheckoutLable
                )}
              </div>
            </div>
            <FormGroup className={s.subjectLabel}>
              <ControlLabel>{formatMessage(messages.subject)}</ControlLabel>
              <Field
                name={`afterCheckOutSubject`}
                type="text"
                component={InputFieldComponent}
                placeholder={formatMessage(messages.enterSubject)}
                inputClass={cx(s.faqinputfield)}
              />
            </FormGroup>
            <FormGroup className={`${s.space5} ${s.subjectLabel}`}>
              <ControlLabel>{formatMessage(messages.mailBody)}</ControlLabel>
              {typeof window !== "undefined" && this.ReactQuill ? (
                <Field
                  name="afterCheckOutContent"
                  component={this.renderQuill}
                />
              ) : (
                <div>Rich text editor not available</div>
              )}
            </FormGroup>
          </div>

          <div className={bt.textAlignRight}>
            <Button
              className={cx(bt.btnPrimary, bt.btnBig, s.customSave)}
              type="submit"
              disabled={isDisabled}
            >
              <FormattedMessage {...messages.save} />
            </Button>
          </div>
        </form>
      </div>
    );
  }
}

InboxMessageForm = reduxForm({
  form: "getHostEmailSetting",
  validate,
})(InboxMessageForm);

export default compose(
  injectIntl,
  withStyles(s, bt),
  graphql(GetHostEmailTemplateQuery, {
    name: "getHostEmailTemplateData",
    options: {
      ssr: false,
      fetchPolicy: "network-only",
    },
    props: ({ getHostEmailTemplateData }) => {
      const getHostEmailSetting = getHostEmailTemplateData?.getHostEmailSetting;
      
      return {
        getHostEmailTemplateData,
        initialValues: {
          id: getHostEmailSetting != null ? getHostEmailSetting.id : null,
          beforeCheckInContent: getHostEmailSetting?.id ? getHostEmailSetting?.beforeCheckInContent : DEFAULT_NOTIFY_EMAIL.BEFORE_CHECKIN.CONTENT,
          afterCheckInContent: getHostEmailSetting?.id ? getHostEmailSetting?.afterCheckInContent : DEFAULT_NOTIFY_EMAIL.AFTER_CHECKIN.CONTENT,
          beforeCheckOutContent: getHostEmailSetting?.id ? getHostEmailSetting?.beforeCheckOutContent : DEFAULT_NOTIFY_EMAIL.BEFORE_CHECKOUT.CONTENT,
          afterCheckOutContent: getHostEmailSetting?.id ? getHostEmailSetting?.afterCheckOutContent : DEFAULT_NOTIFY_EMAIL.AFTER_CHECKOUT.CONTENT,
          beforeCheckInSubject: getHostEmailSetting?.id ? getHostEmailSetting?.beforeCheckInSubject : DEFAULT_NOTIFY_EMAIL.BEFORE_CHECKIN.SUBJECT,
          afterCheckInSubject: getHostEmailSetting?.id ? getHostEmailSetting?.afterCheckInSubject : DEFAULT_NOTIFY_EMAIL.AFTER_CHECKIN.SUBJECT,
          beforeCheckOutSubject: getHostEmailSetting?.id ? getHostEmailSetting?.beforeCheckOutSubject : DEFAULT_NOTIFY_EMAIL.BEFORE_CHECKOUT.SUBJECT,
          afterCheckOutSubject: getHostEmailSetting?.id ? getHostEmailSetting?.afterCheckOutSubject : DEFAULT_NOTIFY_EMAIL.AFTER_CHECKOUT.SUBJECT,
          isEnableBeforeCheckIn: getHostEmailSetting?.isEnableBeforeCheckIn || 0,
          dayBeforeCheckIn: getHostEmailSetting?.dayBeforeCheckIn || 1,
          isEnableAfterCheckIn: getHostEmailSetting?.isEnableAfterCheckIn || 0,
          dayAfterCheckIn: getHostEmailSetting?.dayAfterCheckIn || 1,
          isEnableBeforeCheckOut: getHostEmailSetting?.isEnableBeforeCheckOut || 0,
          dayBeforeCheckOut: getHostEmailSetting?.dayBeforeCheckOut || 1,
          isEnableAfterCheckOut: getHostEmailSetting?.isEnableAfterCheckOut || 0,
          dayAfterCheckOut: getHostEmailSetting?.dayAfterCheckOut || 1,
          timeBeforeCheckIn: getHostEmailSetting?.timeBeforeCheckIn
            ? getHostEmailSetting.timeBeforeCheckIn.split(" ")[0]
            : "",
          timeAfterCheckIn: getHostEmailSetting?.timeAfterCheckIn
            ? getHostEmailSetting.timeAfterCheckIn.split(" ")[0]
            : "",
          timeBeforeCheckOut: getHostEmailSetting?.timeBeforeCheckOut
            ? getHostEmailSetting.timeBeforeCheckOut.split(" ")[0]
            : "",
          timeAfterCheckOut: getHostEmailSetting?.timeAfterCheckOut
            ? getHostEmailSetting.timeAfterCheckOut.split(" ")[0]
            : "",
          timeBeforeCheckInPeriod: getHostEmailSetting?.timeBeforeCheckIn
            ? getHostEmailSetting.timeBeforeCheckIn.split(" ")[1]
            : "AM",
          timeAfterCheckInPeriod: getHostEmailSetting?.timeAfterCheckIn
            ? getHostEmailSetting.timeAfterCheckIn.split(" ")[1]
            : "AM",
          timeBeforeCheckOutPeriod: getHostEmailSetting?.timeBeforeCheckOut
            ? getHostEmailSetting.timeBeforeCheckOut.split(" ")[1]
            : "AM",
          timeAfterCheckOutPeriod: getHostEmailSetting?.timeAfterCheckOut
            ? getHostEmailSetting.timeAfterCheckOut.split(" ")[1]
            : "AM",
        },
      };
    },
  })
)(InboxMessageForm);
